import React from "react";
import { LocalDate } from "@js-joda/core";

import { QueryParams, useQueryParams } from "../../../../shared/hooks/useQueryParams";
import {
  CaregiverId,
  ContractTypeId,
  OfficeId,
  PatientId,
  PatientTaskTemplateId,
} from "../../../../shared/schema/schema";

export type PatientTaskNewStatus = "COMPLETED" | "INCOMPLETED" | "APPROVED";

export type TasksNewFilters = {
  scheduledFrom: LocalDate | null;
  scheduledTo: LocalDate | null;
  statuses: PatientTaskNewStatus[];
  taskTemplateIds: PatientTaskTemplateId[];
  caregiverIds: CaregiverId[];
  patientIds: PatientId[];
  contractTypeIds: ContractTypeId[];
  officeIds: OfficeId[];
  page: number;
  pageSize: number;
  sortDirection: "ASC" | "DESC";
};

const DEFAULT_FILTERS: TasksNewFilters = {
  scheduledFrom: null,
  scheduledTo: null,
  statuses: [],
  taskTemplateIds: [],
  caregiverIds: [],
  patientIds: [],
  contractTypeIds: [],
  officeIds: [],
  page: 1,
  pageSize: 25,
  sortDirection: "DESC",
};

const TasksNewFiltersContext = React.createContext<QueryParams<TasksNewFilters> | null>(null);

export function TasksNewFiltersProvider({ children }: { children: React.ReactNode }) {
  const filters = useQueryParams<TasksNewFilters>({
    storageKey: ["tasksNewFilters"],
    defaultOptions: DEFAULT_FILTERS,
  });
  return (
    <TasksNewFiltersContext.Provider value={filters}>{children}</TasksNewFiltersContext.Provider>
  );
}

export function useTasksNewFilters(): QueryParams<TasksNewFilters> {
  const ctx = React.useContext(TasksNewFiltersContext);
  if (ctx === null) {
    throw new Error("useTasksNewFilters must be used inside a TasksNewFiltersProvider");
  }
  return ctx;
}
